import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { onAgendaViewDateChanged } from '../actions/publicActions';
import { today } from 'owa-datetime';

/**
 * Mutator to update the date at top of agenda view.
 */
const updateDateAtTop = mutator(onAgendaViewDateChanged, actionMessage => {
    const { newDate } = actionMessage;
    const store = getStore();
    store.dateAtTop = newDate || today();
});

export default updateDateAtTop;
